// app/javascript/projects/components/ProjectsDisplay.jsx
import React, { useState } from 'react';
import { Alert } from 'ui';
import BillingModalMainBilling from './BillingModalMainBilling';
import BillingModalSchedule from './BillingModalSchedule';
import BillingModalPaymentMethod from './BillingModalPaymentMethod';
import ModalDivider from '../modal/ModalDivider';

/**
 * Main billing page - composes subscription, schedule, and payment components
 */
const BillingModalMain = () => {
  const [error, setError] = useState(null);

  return (
    <div>
      {error && error.error && (
        <Alert variant="warning">{error.message}</Alert>
      )}

      <BillingModalMainBilling />
      
      <ModalDivider />
      
      <BillingModalSchedule />
      
      <BillingModalPaymentMethod onError={setError} />
    </div>
  );
};

export default BillingModalMain;